import React, { useMemo, useState } from 'react';
import { Button, Menu, MenuItem, Typography } from '@material-ui/core';
import {
  ArrowDropDown as ArrowDropDownIcon,
  GetApp as GetAppIcon
} from '@material-ui/icons';

import { ApiParams } from '../../../common/api/api';
import {
  JiraIssuesFilterOptions,
  useExportJiraIssuesUrl
} from '../JiraConnect.hooks';
import {
  JiraConnect,
  JiraConnectConfigExportPreset
} from '../JiraConnect.interface';

export interface JiraExportButtonProps {
  jiraConnect?: JiraConnect;
  options: JiraIssuesFilterOptions;
}

const JiraExportButton: React.FC<JiraExportButtonProps> = (
  props: JiraExportButtonProps
) => {
  const { options, jiraConnect } = props;
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  const { getViewUrl } = useExportJiraIssuesUrl(options);

  const presets: JiraConnectConfigExportPreset[] = useMemo(() => {
    return jiraConnect?.config?.exportPresets || [];
  }, [jiraConnect]);

  const onSelect = (
    apiParams?: ApiParams,
    filename: string = 'JIRA Issues.docx'
  ) => {
    const url: string = getViewUrl(apiParams, filename).toString();
    url && window.open(url);
    // log url
    const params: string = url.slice(url.indexOf('?'), url.length);
    console.log('Export URL:', new URLSearchParams(params).get('src'));
  };

  return (
    <span>
      <Button
        color='primary'
        variant='contained'
        className='flex-label'
        endIcon={presets.length === 0 ? <GetAppIcon /> : <ArrowDropDownIcon />}
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          if (presets.length === 0) {
            onSelect();
          } else {
            setMenuAnchorEl(event.currentTarget);
          }
        }}
      >
        Export
      </Button>
      <Menu
        id='jira-export-menu'
        keepMounted
        open={!!menuAnchorEl}
        anchorEl={menuAnchorEl}
        onClose={() => setMenuAnchorEl(null)}
      >
        {presets.map((preset: JiraConnectConfigExportPreset) => (
          <MenuItem
            key={preset.id}
            onClick={() => {
              onSelect(
                { presetId: preset.id },
                `${preset.name || 'Untitled'}.docx`
              );
            }}
          >
            {preset.name || (
              <Typography variant='body2' color='textSecondary'>
                Untitled
              </Typography>
            )}
          </MenuItem>
        ))}
      </Menu>
    </span>
  );
};

export default JiraExportButton;
